export default {
  PARTICIPANT: 'PARTICIPANT',
  CAMPAIGNS: 'CAMPAIGNS',
};
